import { type ApiStatusSuffix, ApiStatusSuffixes } from '../constants/ApiActions';

import { OperationNames, OperationNameToSchemaMap } from './constants';
import {
  type GraphQLOperationKeyName,
  type GraphQLOperationKeyNameAction,
  type GraphQLSchema,
} from './types';

export function getGraphQLActionType(
  operationKeyName: GraphQLOperationKeyName,
  suffix: ApiStatusSuffix,
): GraphQLOperationKeyNameAction {
  return `GRAPHQL_${operationKeyName}_${suffix}`;
}

export function getGraphQLActionTypes(
  operationKeyName: GraphQLOperationKeyName,
): GraphQLOperationKeyNameAction[] {
  return ApiStatusSuffixes.map(suffix => getGraphQLActionType(operationKeyName, suffix));
}

export function getSchemaByGraphQLOperationKeyName(
  operationKeyName: GraphQLOperationKeyName,
): GraphQLSchema {
  const operationName = OperationNames[operationKeyName];
  return OperationNameToSchemaMap[operationName];
}
